const base = '/api'
const api = {
    Login: base + '/flyer_student/login',
    Img: base + '/flyer_student/captcha_image',
    QueryStudentScores: base + '/flyer_student/query_student_scores',
    getCategories: base + '/flyer_student/get_categories',
    queryApplyRecords: base + '/flyer_student/query_apply_records',
    createApplyRecord: base + '/flyer_student/create_apply_record',
    ResetPassword: base + '/flyer_student/reset_password',
    getBonusCategories: base + '/flyer_student/bonus/categories',
    getBonusCategoryDetail: base + '/flyer_student/bonus/category',
    uploadBonusFile: base + '/flyer_student/bonus/upload',
    submitBonusApplication: base + '/flyer_student/bonus/apply',
    getBonusApplications: base + '/flyer_student/bonus/applications',
    getSemesters: base + '/flyer_student/get_semesters',
    queryStudentGrades: base + '/flyer_student/query_student_grades',
    getSemesterCourses: (semesterId) => `${base}/flyer_student/get_semester_courses/${semesterId}`,
    
    // 周报相关接口
    checkLeaderPermission: base + '/flyer_student/weekly_report/check_permission',
    getTrainingStages: base + '/flyer_student/weekly_report/training_stages',
    getCurrentWeek: base + '/flyer_student/weekly_report/current_week',
    getLastWeekReport: base + '/flyer_student/weekly_report/last_week',
    submitWeeklyReport: base + '/flyer_student/weekly_report/submit',
    getWeeklyReports: base + '/flyer_student/weekly_report/list',
    getWeeklyReportDetail: base + '/flyer_student/weekly_report/detail',
    getBatchStudents: base + '/flyer_student/weekly_report/batch_students',
    
    // 月报相关接口
    checkMonthlyReportRequired: base + '/flyer_student/monthly_report/check_required',
    getMonthlyReport: base + '/flyer_student/monthly_report/get',
    submitMonthlyReport: base + '/flyer_student/monthly_report/submit',
    getMonthlyReportsList: base + '/flyer_student/monthly_report/list',
    getBatchMonthlyReportsStatus: base + '/flyer_student/monthly_report/batch_status',
    getBatchStudentMonthlyReport: base + '/flyer_student/monthly_report/batch_detail',
    
    // 报告设置相关接口
    getReportSettings: (reportType) => `${base}/flyer_student/report_settings?report_type=${reportType}`,
}
// 添加邮件通知API
api.sendEmailReminder = base + '/flyer_student/monthly_report/send_email_reminder'
api.sendBatchEmailReminders = base + '/flyer_student/monthly_report/send_batch_email_reminders'

// 添加消息通知API
api.sendMessageReminder = base + '/flyer_student/monthly_report/send_message_reminder'
api.sendBatchMessageReminders = base + '/flyer_student/monthly_report/send_batch_message_reminders'

export default api
